export const messages = {
  en: {
    assetInventory: {
      title: 'Asset Inventory',
      searchCondition: 'Search Condition',
      warehouse: 'Warehouse',
      selectWarehouse: 'Please select warehouse',
      inventoryPerson: 'Inventory Person',
      inputInventoryPerson: 'Please input inventory person',
      status: 'Status',
      selectStatus: 'Please select status',
      search: 'Search',
      reset: 'Reset',
      inventory: 'Inventory',
      inventoryNo: 'Inventory No',
      inventoryTime: 'Inventory Time',
      inventoryWarehouse: 'Inventory Warehouse',
      bookQuantity: 'Book Quantity',
      inventoryQuantity: 'Inventory Quantity',
      inventoryProfit: 'Inventory Profit',
      inventoryLoss: 'Inventory Loss',
      profitAmount: 'Profit Amount',
      lossAmount: 'Loss Amount',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      stockIn: 'Stock In',
      confirmDelete: 'Confirm Delete',
      confirmDeleteContent: 'Are you sure to delete this asset inventory?',
      cancel: 'Cancel',
      confirm: 'Confirm'
    }
  },
  zh: {
    assetInventory: {
      title: '资产盘点',
      searchCondition: '查询条件',
      warehouse: '仓库',
      selectWarehouse: '请选择仓库',
      inventoryPerson: '盘点人',
      inputInventoryPerson: '请输入盘点人',
      status: '状态',
      selectStatus: '请选择状态',
      search: '查询',
      reset: '重置',
      inventory: '盘点',
      inventoryNo: '盘点单号',
      inventoryTime: '盘点时间',
      inventoryWarehouse: '盘点仓库',
      bookQuantity: '账面数量',
      inventoryQuantity: '盘点数量',
      inventoryProfit: '盘盈',
      inventoryLoss: '盘亏',
      profitAmount: '盘盈金额',
      lossAmount: '盘亏金额',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      stockIn: '入库',
      confirmDelete: '确认删除',
      confirmDeleteContent: '确定删除资产盘点',
      cancel: '点错了',
      confirm: '确认删除'
    }
  }
}